import { Box, CircularProgress } from "@mui/material";
import { type FieldProps, useGetList } from "react-admin";

import { RolesTable } from "@/components/RolesTable";
import { useTypedFieldValue } from "@/hooks";
import { type RoleEntity } from "@/modules/roles/types";

export const RolesTableField = <RecordType extends Record<string, unknown>>(
  props: FieldProps<RecordType>,
) => {
  const { isLoading, data } = useGetList<RoleEntity>("roles");
  const value = useTypedFieldValue<string[], RecordType>(props) ?? [];

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "40vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <RolesTable rules={value} entities={data ?? []} isDisabled />;
};
